import { StyledButton } from 'components/shared/Button/styles';
import { StyledSecondaryButton } from 'components/shared/SecondaryButton/styled';
import styled from 'styled-components';
export const StyledAdminList = styled.div`
  ${StyledButton} {
    padding: 0.7rem 2.8rem;
    border-radius: 9px;
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg1 : props.theme.text2)};
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 150%; /* 18px */
    text-transform: capitalize;

    @media screen and (min-width: 768px) {
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (min-width: 1440px) {
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 150%; /* 27px */
    }
    @media screen and (max-width: 1440px) {
      padding: 0.8rem 1.6rem;
    }
  }

  ${StyledSecondaryButton} {
    color: ${(props) => (props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2)};
    border-color: ${(props) =>
      props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2};
    padding: 0.8rem 1.6rem;
    border-radius: 9px;

    font-size: 1.2rem;
    font-weight: 600;
    line-height: normal;

    &:hover {
      color: ${(props) => (props.theme.id === 'dark' ? props.theme.bg1 : props.theme.text2)};
      background-color: ${(props) =>
        props.theme.id === 'dark' ? props.theme.button1 : props.theme.text2};
    }

    @media screen and (min-width: 768px) {
      font-size: 1.4rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (min-width: 1440px) {
      font-size: 1.8rem;
      font-weight: 700;
      line-height: 150%; /* 21px */
    }
    @media screen and (max-width: 1200px) {
      max-height: 5.5rem;
    }
  }

  padding: 1.6rem;

  .admin-list-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2.8rem;
    width: 100%;
    height: 100%;

    .admin-list-header__controls {
      display: flex;
      width: 100%;
    }
  }

  .admin-list-body {
    overflow-x: auto;
    padding-bottom: 1.5rem;
    scrollbar-color: #7456ca #7456ca;

    &::-webkit-scrollbar {
      width: 0;
      height: 15px;
    }

    &::-webkit-scrollbar-track {
      border-radius: 5px;
      background-color: ${(props) =>
        props.theme.id === 'dark' ? props.theme.button2 : props.theme.accent4};
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: ${(props) =>
        props.theme.id === 'dark' ? props.theme.button3 : props.theme.accent1};
    }
  }

  .admin-list-footer {
    background-color: red;
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 3.2rem;
  }
`;
